export const permissionMatrix = (permission) => {
    const matrix = {}

    Object.values(permission).forEach((perm) => {
        const [action, level, ...subjectParts] = perm.split("_")
        if (!action || !level || subjectParts.length === 0) {
            return
        }

        const subject = subjectParts.join("_")

        if (!matrix[subject]) {
            matrix[subject] = {}
        }
        if (!matrix[subject][level]) {
            matrix[subject][level] = {}
        }

        matrix[subject][level][action] = perm
    })

    return matrix
}
